import { Outlet } from "react-router-dom";
import Interface from "./Interface";

// Layout persistente: renderiza Topbar/Sidebar uma única vez e troca apenas o
// conteúdo pelo <Outlet/>. Assim a Sidebar não remonta ao navegar e o scroll
// do menu é preservado nativamente pelo DOM.
const MainLayout = () => {
  return (
    <>
      <Interface />
      <Outlet />
    </>
  );
};

export default MainLayout;
